<template>
  <Plan :path="'/entrain'"></Plan>
</template>

<script>
  import Plan from '@/page/modules/plan/detail'
  export default {
    components: { Plan },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/entrain/plan/detail.vue